<template>

	<v-card class="mt-4" :loading="fuenteProductos.listando">

		<v-simple-table>
			<template v-slot:default>
				<thead>
					<tr>
						<th></th>
						<th>Producto</th>
						<th>Precio unitario</th>
						<th>Cantidad</th>
						<th class="text-right">Precio total</th>
						<th></th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(p, i) in productos" :key="`p${i}`">
						<td>
							<v-switch
								v-model="p.enInventario"
								hide-details
							></v-switch>
						</td>
						<td>
							<v-autocomplete
								v-if="p.enInventario"
								label="Producto en inventario:"
								v-model="p.identificador"
								:items="fuenteProductos.listado"
								item-value="identificador"
								item-text="descripción"
								hide-details
							></v-autocomplete>
							<v-text-field
								v-else
								placeholder="Descripción del producto"
								v-model="p.descripción"
								hide-details
							></v-text-field>
						</td>
						<td>
							<v-text-field
								v-model="p.precioUnitario"
								type="number"
								min="1"
								class="num"
								hide-details
							></v-text-field>
						</td>
						<td>
							<v-text-field
								v-model="p.cantidad"
								type="number"
								min="1"
								class="num"
								hide-details
							></v-text-field>
						</td>
						<td class="text-right">
							{{ moneda(p.precioTotal) }}
						</td>
						<td>
							<v-btn fab x-small @click="quitarProducto(i)">
								<v-icon>mdi-delete</v-icon>
							</v-btn>
						</td>
					</tr>
				</tbody>
				<tfoot>
					<tr>
						<td colspan="6">
							<v-btn
								small
								outlined
								class="mt-6 mb-3"
								@click="agregarProducto"
							>
								Agregar producto
							</v-btn>
						</td>
					</tr>
				</tfoot>
			</template>
		</v-simple-table>

		<v-spacer></v-spacer>

		<div class="d-flex mt-3">
			<v-spacer></v-spacer>
			<table class="totales">
				<tbody>
					<tr>
						<td style="text-align: right">TOTAL:</td>
						<td class="text-right">{{ moneda(total) }}</td>
					</tr>
				</tbody>
			</table>
		</div>

	</v-card>

</template>

<script>
import { número, moneda } from '@/../../cliente_comun/utilidades'
import { productos } from '@/../../cliente_comun/fuentes'

export default {
	name: 'productos-factura-compra',
  data: () => ({
		fuenteProductos: productos,
		productos: []
	}),
	mounted: function() {
		this.fuenteProductos.inicializar()
	},
	computed: {
		total: function() {
			let t = 0
			for (let p of this.productos) {
				t += Number(p.precioTotal)
			}

			return t
		}
	},
	watch: {
		'productos': {
			handler: function(productos) {
				for (let i in this.productos) {
					this.productos[i].precioTotal = (Number(this.productos[i].precioUnitario) * Number(this.productos[i].cantidad)).toString()
				}
			},
			deep: true
		}
	},
	methods: {
		número,
		moneda,
		agregarProducto: function() {
			this.productos.push({
				identificador: '',
				descripción: '',
				cantidad: 1,
				precioUnitario: '',
				precioTotal: '',
				enInventario: true
			})
		},
		quitarProducto: function(i) {
			this.productos.splice(i, 1)
		},
		obtenerDatos: function() {
			return {
				productos: this.productos,
				total: this.total,
			}
		},
		limpiar: function() {
			this.productos = []
		}
	}
}
</script>

<style scoped>

tbody > tr > td > .v-input {
	margin: 0;
}

.num {
	width: 90px;
	float: right;
}

.totales tr > td {
	font-weight: 500;
}

.totales tr > td:last-child {
	padding: 10px 20px;
}

</style>